
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.333 13.167a.667.667 0 100 1.333h3.333c.737 0 1.334-.597 1.334-1.333V3.833c0-.736-.597-1.333-1.334-1.333H9.333a.667.667 0 000 1.333h3.333v9.334H9.333z","fill":"#008C89"}}),_c('path',{attrs:{"d":"M10.475 8.967a.664.664 0 00.191-.465v-.004c0-.17-.065-.34-.195-.47L7.804 5.363a.667.667 0 10-.942.943L8.39 7.833H2a.667.667 0 000 1.334h6.39l-1.528 1.528a.667.667 0 10.942.943l2.667-2.666.004-.005z","fill":"#008C89"}})])
          )
        }
      }
    